import { merge, delay } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { generateClientSymbolsRoute, generateClientSymbolsServerRoute } from '@cbridge-packages/routing-client-admin';
import { SymbolClientAction } from '@cbridge-packages/symbol-client';

export const toggleViewSymbolClientSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(SymbolClientAction.create.done),
    delay(100),
    map(({ params }) => {
      const { nodeId, serverId, name } = params;
      if (serverId) {
        return RouterAction.replace([generateClientSymbolsServerRoute(serverId, name)]);
      } else {
        return RouterAction.replace([generateClientSymbolsRoute(nodeId, name)]);
      }
    }),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(SymbolClientAction.update.done),
    mergeMap(({ params }) => {
      const { nodeId, serverId, name } = params;
      const routeAction = serverId
        ? RouterAction.replace([generateClientSymbolsServerRoute(serverId, name)])
        : RouterAction.replace([generateClientSymbolsRoute(nodeId, name)]);
      const loadAction = serverId
        ? SymbolClientAction.load.started({ serverId, name })
        : SymbolClientAction.load.started({ nodeId, name });
      return [routeAction, loadAction];
    }),
  ),
);
